module.exports = __webpack_public_path__ + "img/Werbinich.8e9e8345.jpg";